import { attorneysAPI } from "@/views/profile/services/api";

export const getAttorneys = async () => {
  try {
    const res = await attorneysAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const uploadAttorney = async (formData) => {
  const res = await attorneysAPI.uploadAttorney(formData);
  return res?.data;
};

export const deleteAttorney = async (attorneyId) => {
  try {
    const res = await attorneysAPI.deleteAttorney(attorneyId);
    return res?.data;
  } catch (e) {}
};

